<script setup>
import Card from '@/components/Shared/Card.vue';
import { computed, inject, ref } from 'vue';
import { useForm, usePage } from '@inertiajs/vue3';
import FormEditor from '@/components/Shared/Form/Editor/Index.vue';

const props = defineProps({
  ticket: {
    type: Object,
    required: true,
  },
  isPartner: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['submit']);

const trans = inject('trans');

const editor = ref(null);
const form = useForm({
  message: '',
});

const replyRoute = computed(() => {
  return route('dashboard.partner.support.ticket.reply', props.ticket.id);
});

const replyTo = computed(() => {
  const user = usePage().props.user;

  if (props.ticket.user.id === user.id) {
    return trans('__JSON__.Partner Support');
  }

  return props.ticket.user.name;
});

const submit = () => {
  form.post(replyRoute.value, {
    preserveScroll: true,
    onSuccess: () => {
      form.reset();
      editor.value.reset();
    },
  });
};
</script>

<template>
  <card>
    <template #header>
      <div class="d-flex justify-content-start gap">
        <div class="font-bold text-lg">
          {{ trans('__JSON__.Reply To') }}
          <span class="text-muted font-medium ml-2">
            {{ replyTo }}
          </span>
        </div>
      </div>
    </template>
    <template #body>
      <div>
        <form-editor
          ref="editor"
          v-model="form.message"
          style="background: white"
          :placeholder="trans('__JSON__.Reply here')"
          :error="form.errors.message"
        ></form-editor>
      </div>
    </template>
    <template #footer>
      <div class="d-flex justify-content-end">
        <button @click="submit" class="button">{{ trans('__JSON__.Submit') }}</button>
      </div>
    </template>
  </card>
</template>
